import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Achievements.module.scss";
import { LanguageContext } from "../../contexts/LanguageContext.jsx";
import localforage from "localforage";
import { STORAGE_KEYS } from "../../constants/storage";

import backIcon from "./btn_back.svg";
import closedIcon from "./closed.svg";
import openIcon from "./open.svg";
import achievements from "../../achievements";

const Achievements = ({ onClose }) => {
  const { interfaceText } = useContext(LanguageContext);
  const [visitedPins, setVisitedPins] = useState([]);
  const [cachedImages, setCachedImages] = useState({});

  useEffect(() => {
    const loadData = async () => {
      // Load visited pins
      const pins = (await localforage.getItem("visitedPins")) || [];
      setVisitedPins(pins);

      // Load cached images
      const imageUrls = {};
      for (const achievement of achievements) {
        const cachedImage = await localforage.getItem(
          `${STORAGE_KEYS.IMAGES}_${achievement.image}`
        );
        const cachedViewedImage = await localforage.getItem(
          `${STORAGE_KEYS.IMAGES}_${achievement.imageViewed}`
        );

        if (cachedImage) {
          imageUrls[achievement.image] = URL.createObjectURL(cachedImage);
        }
        if (cachedViewedImage) {
          imageUrls[achievement.imageViewed] =
            URL.createObjectURL(cachedViewedImage);
        }
      }
      setCachedImages(imageUrls);
    };
    loadData();

    // Clean up URLs when component unmounts
    return () => {
      Object.values(cachedImages).forEach((url) => {
        if (url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, []);

  const getImageUrl = (url) => cachedImages[url] || url;

  const viewedCount = visitedPins.length;

  return (
    <div className={styles.achievementsOverlay}>
      <button className={styles.backButton} onClick={onClose}>
        <img src={backIcon} alt="Back" />
      </button>
      <div className={styles.achievementsContent}>
        <h1 className={styles.mainTitle}>{interfaceText.achievement}</h1>
        <h2 className={styles.progressTitle}>
          {viewedCount}/{achievements.length}
        </h2>
        <div className={styles.achievementList}>
          {achievements.map((achievement) => (
            <div className={styles.achievementItem} key={achievement.id}>
              <img
                src={
                  visitedPins.includes(achievement.name)
                    ? getImageUrl(achievement.imageViewed)
                    : getImageUrl(achievement.image)
                }
                alt={`Achievement ${achievement.id}`}
                className={styles.achievementIcon}
              />
              <div className={styles.achievementStatus}>
                {!visitedPins.includes(achievement.name) ? (
                  <img
                    src={closedIcon}
                    alt="Closed"
                    className={styles.closedIcon}
                  />
                ) : (
                  <img src={openIcon} alt="Open" className={styles.openIcon} />
                )}
              </div>
              <div className={styles.achievementText}>
                <p className={styles.achievementNumber}>#{achievement.id}</p>
                <p className={styles.achievementTitle}>{achievement.title}</p>
                {achievement.subtitle && (
                  <p className={styles.achievementSubtitle}>
                    {achievement.subtitle}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Achievements.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Achievements;
